import { render, staticRenderFns } from "./orderTrackingMobile.vue?vue&type=template&id=379e2f7b"
import script from "./orderTrackingMobile.vue?vue&type=script&lang=js"
export * from "./orderTrackingMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports